import { render, staticRenderFns } from "./FileSystemDragOverlay.vue?vue&type=template&id=3b6c636e&scoped=true&"
import script from "./FileSystemDragOverlay.vue?vue&type=script&lang=ts&"
export * from "./FileSystemDragOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./FileSystemDragOverlay.vue?vue&type=style&index=0&id=3b6c636e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6c636e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VOverlay,VRow})
